import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import { fetchPayscaleRequest } from "../../../api/payscale";
import moment from "moment";

class PayscaleDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resource: {
                _id: null,
                level: null,
                basicWage: null,
                ecola: null,
                monthlyWage: null,
                dailyRate: null,
                area: null,
                effectiveDate: null,
                createdAt: null,
                updatedAt: null
            }
        }
    }

    componentDidMount() {
        const { instanceId } = this.props;
        if(instanceId) {
            this.fetchPayscale(instanceId)
        }
    }

    fetchPayscale = (id) => {
        fetchPayscaleRequest(id, result => this.setState({resource: result}), error => console.log(error))
    }

    render() {

        const { 
            _id, 
            level,
            basicWage,
            ecola,
            monthlyWage,
            dailyRate,
            area,
            effectiveDate,
            createdAt, 
            updatedAt
          } = this.state.resource;

        return (
            <Grid fluid>
                <div className="form-header">
                    <h3 className="text-secondary font-weight-bold">
                        Payscale Instance Details
                    </h3>
                    <Button className="btn btn-primary top-btn" onClick={() => this.props.goBack()}>Back to list</Button>
                </div>
                <Row>
                    <Col md={12}>
                        <div className="typo-line">
                            <div>
                            <p className="category">Instance ID</p>
                            {_id || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Level</p>
                            {level || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Basic Wage</p>
                            {basicWage || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">ECOLA</p>
                            {ecola || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Monthly Wage</p>
                            {monthlyWage || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Daily Rate</p>
                            {dailyRate || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Area</p>
                            {area ? area.areaName : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Effective Date</p>
                            {moment.utc(effectiveDate).format('YYYY-MM-DD') || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Created At</p>
                            {createdAt ? moment(createdAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Updated At</p>
                            {updatedAt ? moment(updatedAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <Button className="btn btn-primary bottom-btn" onClick={() => this.props.goToEditForm('payscale', _id)}>Edit</Button>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

export default PayscaleDetails;
